import { posthogWeb } from "src/integrations/posthog/client-web"
import { posthogDebug } from "src/integrations/posthog/events"
import { runOnceInBrowser } from "src/utilities/runOnceInBrowser"
import { create as createStore } from "zustand"
import { ExperimentKey, experiments, ExperimentVariant } from "./experiments"

type Flags = Partial<Record<ExperimentKey, ExperimentVariant<ExperimentKey>>>

type State = {
  loading: boolean
  flags: Flags
}

const defaultState: State = {
  loading: true,
  flags: Object.keys(experiments).reduce<Flags>((result, key) => {
    result[key as ExperimentKey] = "control"
    return result
  }, {}),
}

const store = createStore(() => defaultState)

runOnceInBrowser("posthogWeb.onFeatureFlags", () => {
  posthogWeb.onFeatureFlags((flags: any) => {
    posthogDebug("feature flags updated", flags)

    const newState = {
      loading: false,
      flags: {
        ...defaultState.flags,
        ...Object.keys(experiments).reduce<Flags>((result, key) => {
          result[key as ExperimentKey] = flags[key] ?? "control"
          return result
        }, {}),
      },
    }

    store.setState(newState)
  })
})

export function useExperimentVariant<Key extends ExperimentKey>(key: Key) {
  const loading = store((state) => state.loading)
  const variant = store((state) => (state.flags[key] as ExperimentVariant<Key>) || "control")

  // track exposure of the experiment variant
  posthogWeb.getFeatureFlag(key)

  return { loading, variant }
}

export function setLocalExperimentVariant<Key extends ExperimentKey>(key: Key, value: ExperimentVariant<Key>) {
  posthogWeb.overrideFeatureFlag({ [key]: value || "control" })
  store.setState({ flags: { ...store.getState().flags, [key]: value } })
}
